// Import actual crypto icons
import BtcIcon from '@/assets/Crypto/BtcIcon'
import DogeIcon from '@/assets/Crypto/DogeIcon'
import EthIcon from '@/assets/Crypto/EthIcon'
import TronIcon from '@/assets/Crypto/TronIcon'
import USDCIcon from '@/assets/Crypto/USDCIcon'
import USDTIcon from '@/assets/Crypto/USDTIcon'

// Re-export with consistent naming
export { BtcIcon as BTCIcon }
export { DogeIcon as DOGEIcon }
export { EthIcon as ETHIcon }
export { TronIcon as TRONIcon }
export { USDCIcon }
export { USDTIcon }

// Fiat Currency Icons
export const NGNIcon = () => (
    <div className="h-5 w-5 overflow-hidden rounded-full">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" fill="#008751" />
            <rect x="13" width="7" height="20" fill="#008751" />
            <rect width="7" height="20" fill="#008751" />
        </svg>
    </div>
)

export const USDIcon = () => (
    <div className="h-5 w-5 overflow-hidden rounded-full">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" fill="#B22234" />
            <rect width="20" height="1.54" fill="white" />
            <rect y="3.08" width="20" height="1.54" fill="white" />
            <rect y="6.15" width="20" height="1.54" fill="white" />
            <rect y="9.23" width="20" height="1.54" fill="white" />
            <rect y="12.31" width="20" height="1.54" fill="white" />
            <rect y="15.38" width="20" height="1.54" fill="white" />
            <rect y="18.46" width="20" height="1.54" fill="white" />
            <rect width="8" height="10" fill="#3C3B6E" />
        </svg>
    </div>
)
